module.exports = __webpack_public_path__ + "static/img/jiuquan.0cd5bb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/jiuquan.png
// module id = mQAX
// module chunks = 1